import React from 'react';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import LoadingPlaceholder from '../loading-placeholder';
import Icon from '../icon/index';
class ListScrollLoad extends React.Component {
    constructor() {
        super(...arguments);
        this.scrollToEnd = (isVisible) => {
            const { canLoadMore, isLoading } = this.props;
            if (isVisible && canLoadMore && !isLoading) {
                this.props.scrollToEnd();
            }
        };
    }
    render() {
        const { listData, loadingIcon, isLoading, loadingIconCls, placeholderWrapCls, loadingPlaceholder, firstLoadCompleted, canLoadMore, listEmptyComponent, itemComponentFuc, noMoreComponent, visibilitySensorProps, className, } = this.props;
        return (<LoadingPlaceholder className={placeholderWrapCls} ready={firstLoadCompleted} customBlocks={loadingPlaceholder ? loadingPlaceholder : null}>
        {listData.length > 0
            ? <React.Fragment>
            <div className={classnames('cfm_list_scroll-content', className)}>
              {listData.map((item, index) => {
                return itemComponentFuc ? itemComponentFuc(item, index) : null;
            })}
            </div>
            {canLoadMore
                ? <VisibilitySensor scrollDelay={0} partialVisibility={true} {...visibilitySensorProps} onChange={this.scrollToEnd}>
                  <div className={classnames('cfm_list_scroll-loading', loadingIconCls)}>
                    {isLoading ? loadingIcon : null}
                  </div>
                </VisibilitySensor>
                : noMoreComponent}
          </React.Fragment>
            : listEmptyComponent}
      </LoadingPlaceholder>);
    }
}
ListScrollLoad.defaultProps = {
    listData: [],
    isLoading: false,
    firstLoadCompleted: true,
    canLoadMore: true,
    listEmptyComponent: null,
    noMoreComponent: null,
    visibilitySensorProps: {},
    scrollToEnd: () => { },
    loadingIcon: <Icon size='lg' type='loading_bar'/>,
};
export default ListScrollLoad;



// WEBPACK FOOTER //
// ./components/list-scroll-load/index.tsx